/**
 * Ticket Fields Barrel Export
 * Combines all field definitions into a single fields object.
 *
 * Each per-section bundle is wrapped in `defineFieldConfigMap` so literal
 * keys (and label types) are preserved through the spread. We deliberately
 * do NOT cast to `Record<string, SimpleFieldConfig>` here — that would erase
 * the literal key union and break the `TicketFieldId` derivation downstream.
 */
import { basicFields } from "./basic-fields";
import { statusFields } from "./status-fields";
import { assignmentFields } from "./assignment-fields";
import { timeFields } from "./time-fields";
import { financialFields } from "./financial-fields";
import { metadataFields } from "./metadata-fields";
import { timestampFields } from "./timestamp-fields";
import { reportingFields } from "./reporting-fields";

/**
 * All ticket field definitions combined.
 *
 * The literal key union (i.e. `keyof typeof ticketFields`) is exported
 * separately as `TicketFieldId` from `./ticket-field-ids.ts`.
 */
export const ticketFields = {
  ...basicFields,
  ...statusFields,
  ...assignmentFields,
  ...timeFields,
  ...financialFields,
  ...metadataFields,
  ...timestampFields,
  ...reportingFields,
};
